var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolymer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 1738,
    viewBox: "0 0 256 178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.6 177.98L51.194.605H102.4L204.807 177.98H153.6z",
    fill: "#FF4081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.6 177.98l25.6-44.344 25.607 44.344H153.6z",
    fillOpacity: 0.2,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 133.636l25.6 44.344 25.6-44.344H128z",
    fillOpacity: 0.1,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.4 89.292l25.6 44.344 25.6-44.344h-51.2z",
    fillOpacity: 0.1,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.4 89.292L128 44.948l25.6 44.344h-51.2z",
    fillOpacity: 0.2,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8 44.948l25.6 44.344 25.601-44.344h-51.2z",
    fillOpacity: 0.3,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8 44.948L102.4.605l25.601 44.343h-51.2z",
    fillOpacity: 0.4,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.194.605L76.8 44.948 102.4.605H51.195z",
    fillOpacity: 0.5,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.194 177.98L-.013 89.292l25.606-44.344L102.4 177.98H51.193z",
    fill: "#536DFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.194 177.98L76.8 133.636l25.6 44.344H51.195z",
    fillOpacity: 0.2,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.593 133.636l25.6 44.344L76.8 133.636H25.593z",
    fillOpacity: 0.1,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.593 133.636l25.6-44.344L76.8 133.636H25.593z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.013 89.292l25.606 44.344 25.6-44.344H-.012z",
    fillOpacity: 0.1,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-.013 89.292l25.606-44.344 25.6 44.344H-.012z",
    fillOpacity: 0.2,
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.194 89.292l-25.6-44.344L51.193.605 76.8 44.948 51.194 89.292z",
    fill: "#303F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8 44.948L51.194.605l-25.6 44.343H76.8z",
    fillOpacity: 0.2,
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M204.806 177.98L179.2 133.636l25.606-44.344 25.6 44.344-25.6 44.344z",
    fill: "#3F51B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.407 133.636l-25.6 44.344-25.607-44.344h51.207z",
    fillOpacity: 0.2,
    fill: "#000"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M230.407 133.636L153.6.605h51.207l51.207 88.687-25.606 44.344h-.001z",
    fill: "#7986CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.806 89.292l25.6 44.344 25.607-44.344h-51.207z",
    fillOpacity: 0.2,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.806 89.292l25.6-44.344 25.607 44.344h-51.207z",
    fillOpacity: 0.1,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2 44.948L204.806.605l25.6 44.343H179.2z",
    fillOpacity: 0.1,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.6.605l25.6 44.343L204.808.605H153.6z",
    fillOpacity: 0.2,
    fill: "#000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolymer);
export default __webpack_public_path__ + "static/media/polymer.e34ee705d47e997bf1d97c8cf63b2c92.svg";
export { ForwardRef as ReactComponent };